import {
  CurrencyAmountForm,
  InfoCard,
  Loader,
  ServiceFeeDisplay,
} from '@/shared/components';
import { useTranslation } from 'react-i18next';
import LimitsIcon from '@/shared/assets/limits-icon.svg?react';
import LockIcon from '@/shared/assets/lock-icon.svg?react';
import { type DepositSbpFormProps } from '../model';
import { useCurrencyAmountFormConfig } from '@/shared/lib/formConfigFactory';

export function DepositSbpForm({
  form,
  handleFormSubmit,
  currencyOptions,
  minAmount,
  amountPlaceholder,
  commissionData,
  shouldShowCommission,
  formError,
  onCancel,
  className,
  isLoading,
  limitsInfo,
}: DepositSbpFormProps) {
  const { t } = useTranslation();

  const formConfig = useCurrencyAmountFormConfig({
    currencyOptions,
    minAmount,
    currencyLabelKey: 'common.currencyPlaceholder',
    amountLabelKey: 'common.amount',
    amountPlaceholderKey: amountPlaceholder,
    cancelButtonKey: 'common.cancel',
    showCancelButton: !!onCancel,
    customContentAfterFields:
      shouldShowCommission && commissionData ? (
        <ServiceFeeDisplay
          commissionData={commissionData}
          className="mt-[-1.2rem]"
        />
      ) : undefined,
    customContentBeforeSubmit: (
      <>
        {limitsInfo && (
          <InfoCard
            title={t('depositMethods.sbp.limits.title')}
            icon={<LimitsIcon className="size-[1.6rem]" />}
            titleClassName="text-primary">
            <div className="text-[1.4rem] text-muted-foreground space-y-[0.4rem]">
              {limitsInfo.split('\n').map(text => (
                <div key={text}>{text}</div>
              ))}
            </div>
          </InfoCard>
        )}

        <InfoCard
          title={t('depositMethods.sbp.confirmation.title')}
          icon={<LockIcon className="size-[1.6rem]" />}
          titleClassName="text-primary">
          <div className="text-[1.4rem] text-muted-foreground">
            {t('depositMethods.sbp.confirmation.description')}
          </div>
        </InfoCard>
      </>
    ),
    className,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-[4rem]">
        <Loader />
      </div>
    );
  }

  return (
    <CurrencyAmountForm
      config={formConfig}
      form={form}
      onSubmit={handleFormSubmit}
      error={formError}
    />
  );
}
